// extracted by mini-css-extract-plugin
export var box = "_57-0";
export var check = "_57-1";
export var checkboxButton = "_57-6";
export var checkboxGroup = "_57-5";
export var disabled = "_57-7";
export var ghost = "_57-9";
export var input = "_57-2";
export var label = "_57-4";
export var normal = "_57-8";
export var uncheck = "_57-3";